import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAzldLjC9rAHqCGUXdfXtNNZoOjES3hLxk",
  authDomain: "fconnectapp-e2605.firebaseapp.com",
  projectId: "fconnectapp-e2605",
  storageBucket: "fconnectapp-e2605.firebasestorage.app",
  messagingSenderId: "738812534346",
  appId: "1:738812534346:web:981a90c534a0cd84c650b3"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); 
// Explicitly bind Functions to the deployed region
export const functions = getFunctions(app, 'us-central1');